'use client';

import React, { memo, useMemo } from 'react';
import AppIcon from './AppIcon';
import AppImage from './AppImage';

interface AppLogoProps {
  src?: string | null;
  alt?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  src,
  alt = 'Birla Open Minds International School Logo',
  iconName = 'SparklesIcon',
  size = 64,
  className = '',
  onClick,
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  const actualSrc = src || '/assets/images/image-1785922021750.png';
  const isLocalMedia =
    typeof actualSrc === 'string' &&
    (actualSrc.startsWith('/media/') || actualSrc.endsWith('.svg'));

  return (
    <div className={containerClassName} onClick={onClick}>
      {actualSrc ? (
        <AppImage
          src={actualSrc}
          alt={alt}
          width={size}
          height={size}
          className="flex-shrink-0 object-contain"
          priority={true}
          unoptimized={isLocalMedia}
        />
      ) : (
        <AppIcon name={iconName} size={size} className="flex-shrink-0" />
      )}
    </div>
  );
});

export default AppLogo;
